import arrayMap from 'lodash/_arrayMap';
import baseGet from 'lodash/_baseGet';
import baseIteratee from 'lodash/_baseIteratee';
import baseMap from 'lodash/_baseMap';
import baseSortBy from 'lodash/_baseSortBy';
import baseUnary from 'lodash/_baseUnary';
import identity from 'lodash/identity';
import isArray from 'lodash/isArray';
import compareMultiple from './compareMultiple';

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function (iteratee) {
      if (isArray(iteratee)) {
        return function (value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  let index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  const result = baseMap(collection, function (value, key, collection) {
    const criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return { criteria, index: ++index, value };
  });

  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

export default baseOrderBy;
